import React from 'react';
import {
    Table,
    Tabs,
    Radio,
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
import { onFieldsChange, getNolmalList,getPhoneConnList,getAgentsInfo} from './action';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';

class OrderList extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
        this.getOtion = this.getOtion.bind(this);
    }

    componentDidMount() {
        this.props.getStatisticList(); //查询nolmal数据(包含腾讯云带宽数据)
        this.props.getPhoneConnList();
        this.props.getAgentsInfo();//代理商信息
    }
    handleOnFieldsChange(fields) {
        console.log("handleOnFieldsChange1");
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'day') {
                if(fields[key].value == null){ //时间点x号清空时候会为null  so要判空
                    _obj['day'] = moment().format('YYYY-MM-DD'); 
                }else{
                    _obj['day'] = moment(fields[key].value).format('YYYY-MM-DD');
                }
            }else{
                _obj[key] = fields[key].value;
            }
        });
        this.props.onFieldsChange(Object.assign(_obj));
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(_obj);
    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => { });
    }

    getOtion(data, name) {
        const option = {
            title: {
                text: name,
            },
            tooltip: {
                trigger: 'axis',
            },
            legend: {
                data: data.legend,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: 40,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data.xAxis,
            },
            yAxis: {
                type: 'value',
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                    'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: data.series,
        };
        return option;
    }

    cleaningEchartsData(xyData, lineName) {
        //console.log("ppp "+JSON.stringify(xyData));
        if (JSON.stringify(xyData) === '[]') {
            return {};
        }
        
        let xAxisData = xyData.xData;
        let legendData = [],seriesData = [];
        legendData = xyData.yData;
        
        let line = {
            name: lineName,
            smooth: true,
            type: 'line',
            data: xyData.yData,
        };
        seriesData.push(line);
        return {
            xAxis: xAxisData,
            series: seriesData,
            legend: legendData,
        };
    }

    render() {
      
        let columns1 = [
            {
                title: '代理名称',
                dataIndex: 'agentName',
            },
            {
                title: '日期',
                dataIndex: 'tm',
            },
            {
                title: '最新连接数',
                dataIndex: 'lastConnectedNum',
            },
            {
                title: '总连接数',
                dataIndex: 'connectedNum',
            },
            {
                title: '客户端数',
                dataIndex: 'clientCount',
            },
            {
                title: '平均连接数',
                dataIndex: 'avg',
            },
        ];
        let columns2 = [
            {
                title: '代理名称',
                dataIndex: 'agentName',
            },
            {
                title: '日期',
                dataIndex: 'tm',
            },
            {
                title: '总连接数',
                dataIndex: 'connectedNum',
            },
            {
                title: '最新连接数',
                dataIndex: 'lastConnectedNum',
            },
            {
                title: '实时带宽/KB',
                dataIndex: 'widthSize',
                render: (text, record) => (
                    (text/1024).toFixed(2)
                )
            },
        ];
        const { loading, statisticList,phoneConnList,nolmalXdata,tencentXYdata} = this.props;

        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                    <Tabs defaultActiveKey="1" onChange={this.updateType}>
                    <TabPane tab="Phone" key="1" >
                       <Table columns={columns1} dataSource={phoneConnList} pagination={false} bordered />
                    </TabPane>
                    
                    <TabPane tab="Nomal" key="2">
                    <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(nolmalXdata, '连接数'), '连接数')}
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(tencentXYdata, '带宽/Mbps'), '外网入带宽')}
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                    </Row>
                      <Table columns={columns2} dataSource={statisticList} pagination={false} bordered />
                    </TabPane>
                    
                </Tabs>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.agentConnentData.loading.loading,
    search: state.agentConnentData.search,
    agents: state.agentConnentData.agents,
    statisticList: state.agentConnentData.statisticList,
    phoneConnList: state.agentConnentData.phoneConnList,
    nolmalXdata: state.agentConnentData.nolmalXdata,
    tencentXYdata: state.agentConnentData.tencentXYdata,

});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getAgentsInfo: () => dispatch(getAgentsInfo()),
    getStatisticList: () => dispatch(getNolmalList()),
    getPhoneConnList: () => dispatch(getPhoneConnList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getStatisticList();
        this.props.getPhoneConnList();
    }

    render() {
        const {agents } = this.props;
        const { getFieldDecorator } = this.props.form;
        
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>连接数统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        
                        <Col span={6}>
                            <FormItem label="合作商" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('agent')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {agents.map((item, index) => {
                                            return (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6} >
                            <FormItem label="日期" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('day')(
                                    <DatePicker
                                        style={{ width: 200 }}
                                        format="YYYY-MM-DD"
                                    />,
                                )}
                            </FormItem>
                           
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                                重置
                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            beginTimeView: {
                value: props.search.beginTimeView,
            },
            agent: {
                value: props.search.agent,
            }
        };
    },
    
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agentConnentData/index.js